export function getFilterItems(metadataValues: MetadataObject[], propertyKey: string): Array<FilterItem> {
  const itemsMap: Map<string, number> = new Map<string, number>();

  metadataValues.forEach(metadataObj => {
    const propertyValue: string = metadataObj[propertyKey] || '';
    const filterValues = getFilterEntriesFromMultiValue(propertyValue);

    if (propertyKey === 'marker_types') {
      // Use a Set to track unique values in this entry
      const uniqueValuesInEntry = new Set(filterValues);
      uniqueValuesInEntry.forEach(value => {
        if (value) {
          itemsMap.set(value, (itemsMap.get(value) || 0) + 1);
        }
      });
    } else {
      // Original logic for other properties
      filterValues.forEach((value: string) => {
        if (value) {
          const currentCount = itemsMap.get(value) || 0;
          itemsMap.set(value, currentCount + 1);
        }
      });
    }
  });
  return Array.from(itemsMap, ([key, count]) => ({ key, count }));
}

export function filterMetadataExclusive(metadataValues: MetadataObject[], activeFilters: Map<string, string[] | null>): MetadataObject[] {
  const filteredMetadata: MetadataObject[] = [];

  metadataValues.forEach((metadataObj: MetadataObject) => {
    let allFiltersApply = true;

    for (const [filterKey, filterValues] of activeFilters.entries()) {
      if (filterValues) {
        const propValue: string = metadataObj[filterKey];
        const propValues: string[] = getFilterEntriesFromMultiValue(propValue);

        const matchesFilter = filterValues.some(filterValue => propValues.includes(filterValue));

        if (!matchesFilter) {
          allFiltersApply = false;
          break;
        }
      }
    }

    if (allFiltersApply) {
      filteredMetadata.push(metadataObj);
    }
  });

  return filteredMetadata;
}

// export function filterMetadata(metadataObjects: MetadataObject[], activeFilters: Map<string, string[] | null>): MetadataObject[] | null {
//
//   let filteredMetadata: MetadataObject[] = [];
//   const filterItems = Array.from(activeFilters.entries());
//
//   for (const [filterKey, filterValues] of filterItems) {
//
//     if (filterValues) {
//       console.log(filterKey)
//       console.log(filterValues)
//       const metadataSubset: MetadataObject[] = filteredMetadata.length > 0 ? filteredMetadata : metadataObjects;
//       const filteredSubset: MetadataObject[] = [];
//
//       for (let j = 0; j < metadataSubset.length; j++) {
//         const metadataObj: metadataObject = metadataSubset[j];
//         const metadataValue = metadataObj[filterKey];
//         const metadataValues: string[] = getFilterEntriesFromMultiValue(metadataValue);
//
//         const matchesFilter = filterValues.some(filterValue => metadataValues.includes(filterValue));
//
//
//         if (matchesFilter) {
//           filteredSubset.push(metadataObj);
//         }
//       }
//
//       filteredMetadata = filteredSubset;
//     }
//   }
//
//   return filteredMetadata;
// }

export function getFilterEntriesFromMultiValue(propertyValue: string) {
  return propertyValue?.split(';').map(item => item.trim()) || [];
}

export function getFilteringStringItem(item: FilterItem, countItems: boolean = true) {
  if (countItems) {
    return `${item?.key} (${item?.count})`;
  }

  return item?.key;
}

/**
 * Removes the count from the filter keys "plant (2230)" to "plant"
 * @param stringItem
 * @param countItems
 */
export function getFilterItemKeyFromString(stringItem: string | readonly string[], countItems: boolean = false) : string[] {

  if(!(stringItem instanceof Array)) {
    stringItem = [stringItem];
  }

  if (!countItems) {
    return stringItem as string[];
  }
  
  const arr: string[] = [];
  let cleanFilterItem = '';

  stringItem.forEach(item => {
    const splits = item.split(' ');
    if (splits.length <= 2) {
      cleanFilterItem = splits[0];
    } else {
      const combinedKey = splits.slice(0, splits.length - 1);
      cleanFilterItem = combinedKey.join(' ');
    }

    arr.push(cleanFilterItem);
  })

  return arr;
}


